<template>
    <el-select v-bind="$attrs">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
export default{
    name:"custom-select",
    data(){
        return {
            options:[]
        }
    },
    created(){
        this.initData()
        
    },
    methods:{
        initData(){
            this.options = this.$attrs.options          
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/custom-select/index.vue